<template>
  <dash-menu :links="links">
    <router-view></router-view>
  </dash-menu>
</template>

<script>
import DashMenu from "./DashMenu";

export default {
  components: {
    DashMenu
  },
  computed: {
    links() {
      let id = this.$route.params.id;
      return [
        {
          name: "Litigation",
          path: `/dash/${id}/litigation`
        }
      ];
    }
  }
};
</script>

<style scoped></style>
